import { Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BodyTextSmall, TitleText } from "~/components/Typographies";
import LinkedEmailAccountSection from "~settings/linkedEmail/components/LinkedEmailAccountSection";

interface LinkedEmailProps {
	hosted?: boolean;
}

const LinkedEmail = ({ hosted = false }: LinkedEmailProps) => {
	const { t } = useTranslation("common");

	return (
		<Paper elevation={0} sx={{ p: 3 }}>
			{!hosted && (
				<TitleText bold sx={{ mb: 1 }}>
					{t("preferences.linkedEmail.title")}
				</TitleText>
			)}
			<BodyTextSmall color="text.secondary" sx={{ display: "block", mb: 3 }}>
				{t("preferences.linkedEmail.description")}
			</BodyTextSmall>
			<LinkedEmailAccountSection />
		</Paper>
	);
};

export default LinkedEmail;
